<template>
  <div>
    <div class="flex">
      <!-- BEGIN: Side Menu -->
      <nav class="side-nav">
        <!-- BEGIN: Logo -->
        <div class="intro-x flex items-center pl-5 pt-4">
          <img alt="" class="w-6" src="@/assets/logo2.svg" />
          <span class="hidden xl:block text-white text-lg ml-3"> TatryKompas </span>
        </div>
        <!-- END: Logo -->
        <div class="side-nav__devider my-6"></div>
        <ul v-if="superAdmin === true || superAdmin === 'true'">
          <li>
            <SideMenuTooltip
              tag="a"
              :content="$t('superadmin.toolsName')"
              href="javascript:;"
              class="side-menu"
              @click="router.push({ name: 'choose-role' })"
              :class="{
                'side-menu--active': route.name === 'choose-role'
              }"
            >
              <div class="side-menu__icon">
                <ToggleRightIcon class="w-4 h-4 mr-2" />
              </div>
              <div class="side-menu__title">
                {{ $t('common.changeRole') }}
              </div>
            </SideMenuTooltip>
          </li>
          <li>
            <SideMenuTooltip
              tag="a"
              :content="$t('superadmin.toolsName')"
              href="javascript:;"
              class="side-menu"
              @click="router.push({ name: 'superadmin-tools-user' })"
              :class="{
                'side-menu--active': route.name === 'superadmin-tools-user'
              }"
            >
              <div class="side-menu__icon">
                <ShieldIcon class="w-4 h-4 mr-2" />
              </div>
              <div class="side-menu__title">
                {{ $t('superadmin.toolsName') }}
              </div>
            </SideMenuTooltip>
          </li>
          <li>
            <SideMenuTooltip
              tag="a"
              :content="$t('superadmin.tools.signUp.title')"
              href="javascript:;"
              class="side-menu"
              @click="router.push({ name: 'superadmin-tools-sign-up-list' })"
              :class="{
                'side-menu--active': route.name.startsWith('superadmin-tools-sign-up')
              }"
            >
              <div class="side-menu__icon">
                <FileTextIcon class="w-4 h-4 mr-2" />
              </div>
              <div class="side-menu__title">
                {{ $t('superadmin.tools.signUp.title') }}
              </div>
            </SideMenuTooltip>
          </li>
          <li>
            <SideMenuTooltip
              tag="a"
              :content="$t('news.list')"
              href="javascript:;"
              class="side-menu"
              @click="router.push({ name: 'superadmin-tools-news' })"
              :class="{
                'side-menu--active': route.name.startsWith('superadmin-tools-news')
              }"
            >
              <div class="side-menu__icon">
                <MessageSquareIcon class="w-4 h-4 mr-2" />
              </div>
              <div class="side-menu__title">
                {{ $t('news.list') }}
              </div>
            </SideMenuTooltip>
          </li>
          <li>
            <SideMenuTooltip
              tag="a"
              :content="$t('news.list')"
              href="javascript:;"
              class="side-menu"
              @click="router.push({ name: 'superadmin-tools-advertisement' })"
              :class="{
                'side-menu--active': route.name.startsWith(
                  'superadmin-tools-advertisement'
                )
              }"
            >
              <div class="side-menu__icon">
                <AwardIcon class="w-4 h-4 mr-2" />
              </div>
              <div class="side-menu__title">
                {{ $t('advertisement.list') }}
              </div>
            </SideMenuTooltip>
          </li>
          <li>
            <SideMenuTooltip
              tag="a"
              :content="$t('news.list')"
              href="javascript:;"
              class="side-menu"
              @click="router.push({ name: 'superadmin-tools-category' })"
              :class="{
                'side-menu--active': route.name.startsWith('superadmin-tools-category')
              }"
            >
              <div class="side-menu__icon">
                <ListIcon class="w-4 h-4 mr-2" />
              </div>
              <div class="side-menu__title">
                {{ $t('category.list') }}
              </div>
            </SideMenuTooltip>
          </li>
        </ul>
        <ul v-if="editor === true || editor === 'true'">
          <li>
            <SideMenuTooltip
              tag="a"
              :content="$t('news.list')"
              href="javascript:;"
              class="side-menu"
              @click="router.push({ name: 'superadmin-tools-news' })"
              :class="{
                'side-menu--active': route.name.startsWith('superadmin-tools-news')
              }"
            >
              <div class="side-menu__icon">
                <MessageSquareIcon class="w-4 h-4 mr-2" />
              </div>
              <div class="side-menu__title">
                {{ $t('news.list') }}
              </div>
            </SideMenuTooltip>
          </li>
          <!-- <li>
            <SideMenuTooltip
              tag="a"
              :content="$t('news.list')"
              href="javascript:;"
              class="side-menu"
              @click="router.push({ name: 'superadmin-tools-advertisement' })"
              :class="{
                'side-menu--active': route.name.startsWith('superadmin-tools-advertisement')
              }"
            >
              <div class="side-menu__icon">
                <AwardIcon class="w-4 h-4 mr-2" />
              </div>
              <div class="side-menu__title">
                {{ $t('advertisement.list') }}
              </div>
            </SideMenuTooltip>
          </li> -->
        </ul>
        <ul>
          <li>
            <SideMenuTooltip
              tag="a"
              :content="$t('common.manual')"
              class="side-menu"
              href="#"
              @click="donwloadManual()"
            >
              <div class="side-menu__icon">
                <HelpCircleIcon class="w-4 h-4 mr-2" />
              </div>
              <div class="side-menu__title">
                {{ $t('common.manual') }}
              </div>
            </SideMenuTooltip>
          </li>
        </ul>
      </nav>
      <!-- END: Side Menu -->
      <!-- BEGIN: Content -->
      <div class="content">
        <AuthTopBar />
        <router-view />
      </div>
      <!-- END: Content -->
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import { helper as $h } from '@/utils/helper'
import AuthTopBar from '@/components/top-bar/AuthTopBar.vue'
import SideMenuTooltip from '@/components/side-menu-tooltip/Main.vue'
import { linkTo, nestedMenu, enter, leave } from './index'
import { ShieldIcon } from '@zhuowenli/vue-feather-icons'
import roleApi from '@/services/security/role.api'

export default defineComponent({
  components: {
    AuthTopBar,
    SideMenuTooltip,
    ShieldIcon
  },
  data() {
    return {
      superAdmin: false,
      editor: false
    }
  },
  mounted() {
    this.superAdmin = localStorage.getItem('auth_superadmin')
    this.editor = localStorage.getItem('auth_editor')
  },
  methods: {
    donwloadManual() {
      roleApi
        .donwloadManual()
        .then((response) => {
          const contentType = response.headers['content-type']
          const blob = new Blob([response.data], { type: contentType })

          const href = window.URL.createObjectURL(blob)

          const anchorElement = document.createElement('a')
          anchorElement.href = href
          anchorElement.download = 'tatrykompasManual.pdf'

          document.body.appendChild(anchorElement)
          anchorElement.click()

          document.body.removeChild(anchorElement)
          window.URL.revokeObjectURL(href)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    }
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const formattedMenu = ref([])
    const sideMenu = computed(() => nestedMenu(store.state.sideMenu.menu, route))

    watch(
      computed(() => route.path),
      () => {
        formattedMenu.value = $h.toRaw(sideMenu.value)
      }
    )

    onMounted(() => {
      cash('body').removeClass('error-page').removeClass('login').addClass('main')
      formattedMenu.value = $h.toRaw(sideMenu.value)
    })

    return {
      formattedMenu,
      router,
      route,
      linkTo,
      enter,
      leave
    }
  }
})
</script>
